var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBetColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DB241C;}\n\t.st1{fill:url(#Path_1299_1_);}\n\t.st2{fill:url(#Path_1300_1_);}\n\t.st3{fill:url(#Path_1301_1_);}\n\t.st4{fill:url(#Path_1302_1_);}\n\t.st5{fill:url(#Path_1303_1_);}\n\t.st6{fill:url(#Path_1304_1_);}\n\t.st7{fill:url(#Path_1305_1_);}\n\t.st8{fill:url(#Path_1306_1_);}\n\t.st9{fill:url(#Path_1307_1_);}\n\t.st10{fill:url(#Path_1308_1_);}\n\t.st11{fill:url(#Path_1309_1_);}\n\t.st12{fill:url(#Path_1310_1_);}\n\t.st13{fill:url(#Path_1311_1_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_2090"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    className: "st0",
    d: "M29.503,18.885c-0.06,0.195-0.135,0.435-0.195,0.645c-0.045,0.18-0.12,0.36-0.18,0.555 c-0.18,0.48-0.375,0.945-0.6,1.395c-0.075,0.15-0.135,0.3-0.225,0.45c-0.375,0.705-0.795,1.395-1.275,2.025 c-0.09,0.12-0.165,0.24-0.255,0.33c-0.15,0.195-0.3,0.375-0.465,0.555c-0.225,0.27-0.45,0.51-0.705,0.75 c-1.86,1.86-4.17,3.21-6.72,3.885c-0.525,0.15-1.065,0.27-1.605,0.33c-0.195,0.045-0.405,0.06-0.615,0.105l-0.72,0.045 C15.628,29.985,15.313,30,14.998,30c-0.315,0-0.63-0.015-0.945-0.03l-0.72-0.045c-0.195-0.03-0.42-0.045-0.615-0.105 c-0.54-0.075-1.08-0.18-1.605-0.33c-2.55-0.675-4.86-2.025-6.72-3.885c-0.255-0.24-0.48-0.48-0.705-0.75 c-0.15-0.18-0.3-0.345-0.45-0.555c-0.105-0.105-0.195-0.21-0.27-0.33c-0.48-0.645-0.915-1.32-1.29-2.025 c-0.09-0.15-0.15-0.3-0.21-0.45c-0.21-0.45-0.42-0.915-0.6-1.395c-0.045-0.18-0.135-0.36-0.18-0.555 c-0.06-0.225-0.135-0.45-0.18-0.645c-0.675-2.55-0.675-5.22,0-7.77c0.045-0.225,0.12-0.435,0.18-0.645 c0.06-0.225,0.135-0.39,0.18-0.555c0.18-0.48,0.39-0.945,0.6-1.425c0.06-0.15,0.135-0.3,0.21-0.435 c0.375-0.72,0.81-1.395,1.305-2.04C3.058,5.91,3.148,5.805,3.238,5.7c0.135-0.195,0.285-0.39,0.45-0.57 c0.21-0.255,0.45-0.495,0.705-0.75c1.86-1.86,4.185-3.195,6.72-3.885c0.525-0.135,1.065-0.255,1.605-0.33 c0.195-0.03,0.42-0.045,0.615-0.09c0.255-0.015,0.48-0.045,0.72-0.06C14.353,0,14.683,0,14.998,0c0.315,0,0.63,0,0.945,0.015 c0.24,0.015,0.48,0.045,0.72,0.06c0.21,0.015,0.42,0.045,0.615,0.09c0.54,0.09,1.08,0.195,1.605,0.33 c2.55,0.675,4.86,2.01,6.72,3.885c0.24,0.24,0.48,0.48,0.705,0.75c0.165,0.18,0.315,0.36,0.465,0.555 c0.09,0.12,0.165,0.21,0.255,0.33c0.48,0.645,0.915,1.335,1.275,2.055c0.075,0.135,0.15,0.285,0.225,0.435 c0.24,0.465,0.42,0.93,0.6,1.395c0.075,0.18,0.135,0.375,0.18,0.57c0.075,0.195,0.135,0.435,0.195,0.63v0.015 C30.163,13.665,30.163,16.335,29.503,18.885z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    transform: "translate(4.645 4.643)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1299_1_",
    cx: 155.9288,
    cy: 1262.4532,
    r: 72.267,
    gradientTransform: "matrix(0.6459 0 0 0.646 -93.5702 -813.9998)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    className: "st1",
    d: "M11.201,2.322H9.536L9.311,2.337l0.12,0.945c0.555-0.075,1.11-0.075,1.665-0.015L11.201,2.322 L11.201,2.322z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1300_1_",
    cx: -673.6132,
    cy: 754.0354,
    r: 43.0665,
    gradientTransform: "matrix(1.0838 0 0 1.081 734.5821 -813.5641)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    className: "st2",
    d: "M7.061,2.967h-0.48L6.566,3.222H6.551h-0.03H6.506L6.491,3.237l0,0L6.476,3.252l0,0 l-0.03,0.015l0,0l-0.03,0.015l0,0l-0.03,0.015l0,0L6.371,3.312l0,0L6.326,3.327l0,0l-0.06,0.045l0,0L6.191,3.417l0,0l-0.12,0.06 l0,0l-0.03,0.03l0,0l-0.03,0.015l0,0L5.996,3.537l0,0l-0.18,0.135l0,0L5.801,3.687l0,0l-0.03,0.015l0,0L5.576,3.837l0.57,0.75 c0.405-0.3,0.84-0.54,1.305-0.75L7.061,2.967z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1301_1_",
    cx: -909.8696,
    cy: 604.8032,
    r: 34.71,
    gradientTransform: "matrix(1.3448 0 0 1.345 1227.8394 -811.916)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    className: "st3",
    d: "M3.821,5.591L3.821,5.591v0.285l0,0v0.015l0,0v0.015l0,0v0.015l0,0l-0.015,0l0,0v0.015l0,0 v0.015l0,0L3.791,5.966l0,0l-0.015,0.03l0,0L3.761,6.012l0,0l-0.015,0.03l0,0l-0.015,0.03l0,0l-0.375,0.24l0,0l-0.015,0.03l0,0 l-0.015,0.03l0,0L3.281,6.447l0,0L3.236,6.552l0,0l-0.06,0.12l0,0l-0.03,0.03l0,0l-0.015,0.03l0,0l-0.015,0.03l0,0v0.015l0,0 v0.015l0,0v0.015l0,0v0.015l0,0v0.015l0,0v0.015l0,0l-0.015,0.03l0,0c-0.03,0.075-0.06,0.15-0.09,0.21l0.87,0.36 c0.21-0.51,0.495-1.005,0.825-1.455l-0.78-0.555L3.821,5.591z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1302_1_",
    cx: -841.0843,
    cy: 641.912,
    r: 37.08,
    gradientTransform: "matrix(1.259 0 0 1.263 1064.4199 -809.215)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    className: "st4",
    d: "M2.321,9.507v0.015l0,0v0.015l0,0v0.03l0,0v0.03l0,0v0.03l0,0v0.165l0,0v0.09l0,0v0.045l0,0 v0.015l0,0v0.03l0,0v0.135l0,0v0.015l0,0v0.015l0,0v0.03l0,0v0.03l0,0v0.03l0,0v0.03l0,0v0.03l0,0v0.15l0,0v0.09l0,0v0.09l0,0 v0.135l0,0v0.045l0,0v0.03l0,0v0.03l0,0v0.03l0,0v0.015l0,0v0.015l0,0v0.015l0,0v0.06l0,0v0.15l0,0v0.03l0,0 c0,0.075,0.015,0.15,0.03,0.24l0.945-0.12c-0.075-0.555-0.075-1.11-0.015-1.68L2.321,9.507L2.321,9.507z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1303_1_",
    cx: -693.9334,
    cy: 731.4568,
    r: 42.249,
    gradientTransform: "matrix(1.1036 0 0 1.105 770.1133 -806.709)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    className: "st5",
    d: "M2.966,13.632L2.966,13.632v0.03l0,0v0.03l0,0v0.015l0,0v0.015l0,0v0.015l0,0v0.015l0,0v0.045 l0,0v0.015l0,0v0.015l0,0v0.03l0,0v0.03l0,0v0.135l0,0v0.015l0,0v0.015l0,0v0.015l0,0l0.015,0.015l0,0l0.015,0.03l0,0v0.015l0,0 l0.015,0.015l0,0l0.015,0.03l0,0l0.015,0.015l0,0l0.015,0.03l0,0l0.015,0.03l0,0l0.015,0.03l0,0l0.045,0.075l0,0l0.045,0.075l0,0 l0.075,0.12l0,0l0.015,0.03l0,0l0.015,0.03l0,0l0.015,0.03l0,0l0.015,0.015l0,0v0.015l0,0l0,0l0,0v0.03l0,0l0.015,0.03l0,0 c0.045,0.06,0.09,0.12,0.135,0.18l0.75-0.57c-0.165-0.345-0.3-0.705-0.405-1.08L2.966,13.632L2.966,13.632z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1304_1_",
    cx: -725.1475,
    cy: 712.613,
    r: 41.241,
    gradientTransform: "matrix(1.1315 0 0 1.132 825.0305 -805.134)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    className: "st6",
    d: "M5.591,16.872h0.33l0.015,0.015l0,0l0.015,0.015l0,0l0.015,0.015l0,0l0.03,0.015l0,0 l0.03,0.015l0,0l0.015,0.015l0,0l0.03,0.015l0,0l0.03,0.015l0,0l0.03,0.015l0,0l0.075,0.045l0,0l0.075,0.045l0,0l0.12,0.06l0,0 l0.03,0.015l0,0l0.03,0.015l0,0l0.03,0.015l0,0l0.015,0.015h0.465l0.03,0.015l0,0l0.21,0.09l0.36-0.885 c-0.525-0.21-1.005-0.495-1.455-0.825l-0.555,0.765L5.591,16.872z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1305_1_",
    cx: -850.317,
    cy: 1246.8684,
    r: 72.267,
    gradientTransform: "matrix(1.264 0 0 0.646 1078.9645 -803.9319)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    className: "st7",
    d: "M9.506,18.386h1.665l0.225-0.03l-0.12-0.945c-0.555,0.075-1.11,0.075-1.665,0.015 L9.506,18.386L9.506,18.386z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1306_1_",
    cx: -745.0854,
    cy: 702.1906,
    r: 40.6665,
    gradientTransform: "matrix(1.1478 0 0 1.148 860.7557 -804.5638)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    className: "st8",
    d: "M13.631,17.741h0.33l0.015-0.015l0,0l0.015-0.015l0,0l0.015-0.015h0.015l0.015-0.015l0,0 l0.03-0.015l0,0l0.015-0.015l0,0l0.03-0.015l0,0l0.03-0.015l0,0l0.03-0.015l0,0l0.075-0.045l0,0l0.075-0.045l0,0l0.12-0.075l0,0 l0.03-0.015l0,0l0.03-0.015l0,0l0.03-0.015l0,0l0.015-0.015h0.015l0.03-0.015l0,0c0.06-0.045,0.12-0.09,0.18-0.135l-0.57-0.75 c-0.45,0.345-0.93,0.63-1.44,0.855l0.39,0.87L13.631,17.741z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1307_1_",
    cx: -917.9716,
    cy: 600.6836,
    r: 34.71,
    gradientTransform: "matrix(1.3449 0 0 1.345 1236.4028 -806.3741)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    className: "st9",
    d: "M16.886,15.102L16.886,15.102L16.886,15.102L16.886,15.102v-0.015l0,0v-0.015l0,0l0,0l0,0 v-0.015l0,0v-0.015l0,0l0.015-0.015l0,0l0,0l0,0l0.015-0.015l0,0l0.015-0.015l0,0l0.015-0.015l0,0l0.015-0.03l0,0l0.015-0.03l0,0 l0.015-0.015l0,0l0.015-0.03l0,0l0.015-0.03l0,0l0.015-0.03l0,0l0.045-0.075l0,0l0.03-0.075l0,0l0.06-0.12l0,0l0.015-0.03l0,0 l0.015-0.03l0,0l0.015-0.03l0,0l0.015-0.015l0,0v-0.015l0,0l0,0l0,0v-0.045l0,0v-0.015l0,0l0.015-0.03l0,0 c0.03-0.075,0.06-0.135,0.09-0.21l-0.885-0.36c-0.21,0.51-0.495,1.005-0.825,1.455l0.765,0.555L16.886,15.102z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1308_1_",
    cx: -863.7623,
    cy: 646.6489,
    r: 37.08,
    gradientTransform: "matrix(1.2629 0 0 1.254 1081.8872 -809.3151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    className: "st10",
    d: "M18.386,11.201L18.386,11.201v-0.03l0,0v-0.03l0,0v-0.165l0,0v-0.135l0,0v-0.075l0,0v-0.015 l0,0v-0.03l0,0v-0.015l0,0v-0.015l0,0v-0.015l0,0v-0.03l0,0v-0.03l0,0v-0.045l0,0v-0.015l0,0v-0.015l0,0v-0.03l0,0v-0.03l0,0 v-0.075l0,0v-0.03l0,0v-0.075l0,0v-0.03l0,0v-0.075l0,0v-0.09l0,0V9.972l0,0V9.927l0,0v-0.03l0,0v-0.03l0,0v-0.03l0,0V9.821l0,0 l0,0l0,0V9.806l0,0v-0.06l0,0V9.731l0,0V9.627l0,0V9.611l0,0v-0.03l0,0c0-0.075-0.015-0.15-0.03-0.225l-0.945,0.12 c0.075,0.555,0.075,1.11,0.03,1.665l0.945,0.105V11.201z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1309_1_",
    cx: -917.6993,
    cy: 605.2231,
    r: 34.7355,
    gradientTransform: "matrix(1.3443 0 0 1.344 1235.6428 -811.8739)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    className: "st11",
    d: "M17.741,7.062L17.741,7.062V7.046l0,0v-0.03l0,0v-0.06l0,0V6.912l0,0V6.837l0,0V6.822l0,0 V6.776l0,0V6.732l0,0v-0.03l0,0v-0.03l0,0l0,0l0,0v-0.09l0,0l-0.255-0.015l0,0l-0.015-0.015l0,0v-0.03l0,0l0-0.015l0,0l-0.06-0.12 l0,0l-0.03-0.015l0,0l-0.015-0.03l0,0l-0.015-0.03l0,0l-0.015-0.03l0,0l-0.045-0.075l0,0l-0.045-0.075l0,0l-0.075-0.105l0,0 l-0.03-0.03l0,0l-0.015-0.03l0,0l-0.075-0.105l0,0l-0.015-0.015l0,0v-0.03l0,0v-0.09l0,0V5.712l0,0l-0.015-0.015l0,0 c-0.045-0.06-0.09-0.12-0.135-0.18l-0.75,0.57c0.345,0.45,0.63,0.93,0.855,1.44l0.87-0.39L17.741,7.062z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1310_1_",
    cx: -728.5521,
    cy: 720.6952,
    r: 41.277,
    gradientTransform: "matrix(1.1315 0 0 1.131 830.111 -813.563)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    className: "st12",
    d: "M15.101,3.822h-0.03l-0.36-0.27l0,0l-0.015-0.015l0,0l-0.015-0.015l0,0l-0.015,0l0,0 l-0.015-0.015l0,0l-0.03-0.015l0,0l-0.03-0.015l0,0l-0.015-0.015l0,0l-0.03-0.015l0,0l-0.03-0.015l0,0l-0.03-0.015l0,0 l-0.075-0.045l0,0l-0.075-0.045l0,0l-0.12-0.06l0,0l-0.03-0.015l0,0l-0.03-0.015h-0.015l-0.03-0.015h-0.015l-0.21-0.15h-0.09 l-0.03-0.015l0,0l-0.21-0.09l-0.375,0.87c0.51,0.21,1.005,0.495,1.455,0.825l0.555-0.765L15.101,3.822z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_1311_1_",
    cx: -1821.359,
    cy: 40.9945,
    r: 2.334,
    gradientTransform: "matrix(20.0002 0 0 20.007 36436.4062 -814.0004)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6EAED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B8BC"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    className: "st13",
    d: "M29.488,11.115c-0.06-0.21-0.12-0.435-0.195-0.645c-0.045-0.195-0.12-0.375-0.18-0.555 c-0.18-0.48-0.375-0.945-0.6-1.41c-0.06-0.15-0.135-0.3-0.21-0.435c-0.375-0.72-0.795-1.395-1.29-2.04 c-0.075-0.12-0.165-0.225-0.255-0.33c-0.15-0.195-0.3-0.375-0.465-0.555c-0.21-0.255-0.45-0.51-0.69-0.75 c-1.86-1.86-4.185-3.21-6.72-3.885c-0.525-0.135-1.065-0.255-1.605-0.33c-0.195-0.045-0.405-0.06-0.615-0.09 c-0.24-0.015-0.48-0.045-0.72-0.06C15.628,0.015,15.313,0,14.998,0c-0.315,0-0.63,0.015-0.945,0.03 c-0.24,0.015-0.48,0.045-0.72,0.06c-0.21,0.03-0.42,0.045-0.615,0.09c-0.54,0.075-1.08,0.195-1.605,0.33 c-2.535,0.675-4.86,2.025-6.72,3.885c-0.24,0.24-0.48,0.495-0.69,0.75C3.538,5.325,3.388,5.505,3.238,5.7 c-0.09,0.105-0.18,0.21-0.255,0.33c-0.48,0.645-0.915,1.32-1.29,2.04c-0.075,0.135-0.15,0.285-0.21,0.435 c-0.225,0.465-0.42,0.93-0.6,1.41c-0.06,0.18-0.135,0.36-0.18,0.555c-0.075,0.21-0.135,0.435-0.195,0.645 c-0.675,2.55-0.675,5.22,0,7.77c0.06,0.21,0.12,0.435,0.195,0.645c0.045,0.195,0.12,0.375,0.18,0.555 c0.18,0.48,0.375,0.945,0.6,1.41c0.06,0.15,0.135,0.3,0.21,0.435c0.375,0.72,0.81,1.395,1.29,2.04 c0.075,0.12,0.165,0.225,0.255,0.33c0.15,0.195,0.3,0.375,0.465,0.555c0.21,0.255,0.45,0.51,0.69,0.75 c1.86,1.86,4.185,3.195,6.72,3.885c0.525,0.135,1.065,0.255,1.605,0.33c0.195,0.045,0.405,0.06,0.615,0.09 c0.24,0.015,0.48,0.045,0.72,0.06c0.315,0.015,0.63,0.03,0.945,0.03c0.315,0,0.63-0.015,0.945-0.03 c0.24-0.015,0.48-0.045,0.72-0.06c0.21-0.03,0.42-0.045,0.615-0.09c0.54-0.075,1.08-0.195,1.605-0.33 c2.535-0.675,4.86-2.025,6.72-3.885c0.24-0.24,0.48-0.495,0.69-0.75c0.165-0.18,0.315-0.36,0.465-0.555 c0.09-0.105,0.18-0.21,0.255-0.33c0.495-0.645,0.915-1.32,1.29-2.04c0.075-0.135,0.15-0.285,0.21-0.435 c0.225-0.465,0.42-0.93,0.6-1.41c0.06-0.18,0.135-0.36,0.18-0.555c0.075-0.21,0.135-0.435,0.195-0.645 C30.163,16.335,30.163,13.665,29.488,11.115L29.488,11.115z M18.688,1.245c2.415,0.645,4.62,1.92,6.375,3.69l-2.88,2.88 c-1.26-1.275-2.835-2.175-4.56-2.625L18.688,1.245z M11.308,1.245l1.065,3.945c-1.725,0.45-3.3,1.365-4.56,2.625l-2.88-2.88 C6.688,3.15,8.893,1.875,11.308,1.245z M1.243,18.69c-0.66-2.415-0.66-4.965,0-7.38l3.945,1.065c-0.48,1.71-0.48,3.54,0,5.25 L1.243,18.69z M11.308,28.755c-2.415-0.645-4.62-1.92-6.375-3.69l2.88-2.88c1.26,1.26,2.835,2.175,4.56,2.625L11.308,28.755z  M16.828,24.24c-0.255,0.045-0.54,0.09-0.81,0.12c-0.045,0-0.09,0.015-0.135,0.015c-0.585,0.06-1.185,0.06-1.77,0 c-0.045,0-0.09-0.015-0.135-0.015c-0.27-0.03-0.555-0.075-0.81-0.12c-0.21-0.045-0.405-0.09-0.6-0.15 c-1.605-0.42-3.06-1.245-4.245-2.43c-0.15-0.15-0.3-0.315-0.45-0.48c-0.12-0.135-0.225-0.27-0.345-0.42 c-0.135-0.18-0.27-0.375-0.405-0.555c-0.3-0.435-0.555-0.915-0.765-1.395c-0.105-0.27-0.21-0.54-0.3-0.81 c-0.06-0.195-0.12-0.375-0.165-0.57c-0.435-1.59-0.435-3.27,0-4.86c0.045-0.195,0.105-0.375,0.165-0.57 c0.09-0.27,0.195-0.54,0.3-0.81c0.21-0.48,0.465-0.96,0.765-1.395c0.135-0.18,0.27-0.375,0.405-0.555 c0.12-0.15,0.225-0.285,0.345-0.42c0.15-0.165,0.3-0.33,0.45-0.48c1.17-1.17,2.625-2.01,4.23-2.43c0.195-0.06,0.39-0.105,0.6-0.15 c0.27-0.06,0.54-0.09,0.81-0.12c0.045,0,0.09-0.015,0.135-0.015c0.585-0.06,1.185-0.06,1.77,0c0.045,0,0.09,0.015,0.135,0.015 c0.27,0.03,0.54,0.06,0.81,0.12c0.21,0.045,0.405,0.09,0.6,0.15c1.605,0.42,3.06,1.245,4.245,2.415c0.15,0.15,0.3,0.315,0.45,0.48 c0.12,0.135,0.225,0.27,0.345,0.42c0.135,0.18,0.27,0.375,0.405,0.555c0.3,0.435,0.555,0.915,0.765,1.395 c0.105,0.27,0.21,0.54,0.3,0.81c0.06,0.195,0.12,0.375,0.165,0.57c0.435,1.59,0.435,3.27,0,4.86 c-0.045,0.195-0.105,0.375-0.165,0.57c-0.09,0.27-0.195,0.54-0.3,0.81c-0.21,0.48-0.465,0.96-0.765,1.395 c-0.135,0.18-0.27,0.375-0.405,0.555c-0.12,0.15-0.225,0.285-0.345,0.42c-0.15,0.165-0.3,0.33-0.45,0.48 c-1.17,1.17-2.625,2.01-4.23,2.43C17.233,24.135,17.038,24.195,16.828,24.24L16.828,24.24z M18.688,28.755l-1.065-3.945 c1.725-0.45,3.3-1.35,4.56-2.625l2.88,2.88C23.308,26.835,21.103,28.11,18.688,28.755L18.688,28.755z M24.808,17.625 c0.48-1.71,0.48-3.54,0-5.25l3.945-1.065c0.66,2.415,0.66,4.965,0,7.38L24.808,17.625z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBetColor);
export default __webpack_public_path__ + "static/media/menu-bet-color.726c82e1933a1a8f499f18c7d5b34d00.svg";
export { ForwardRef as ReactComponent };